import React, { useEffect, useState } from "react";
import ProviderStatistics from "./ProviderStatistics/ProviderStatistics";
import ProviderDistribution from "./ProviderDistribution/ProviderDistribution";
import TopFiveGames from "./TopFiveGames/TopFiveGames";
import { Line } from "react-chartjs-2";
import KpiCard from "../../CommonComponents/Dashboard/KpiCard/KpiCard";
import { KPI_CARD_BACKGROUND } from "../../../utils/Constants";
import CustomAutoComplete from "../../CommonComponents/CustomAutoComplete/CustomAutoComplete";
import DashboardLineChart from "../../CommonComponents/Dashboard/DashboardLineChart/DashboardLineChart";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
} from "chart.js";

import { formatNumber } from "chart.js/helpers";
import dayjs from "dayjs";
import { ChevronDown, ChevronUp, Filter } from "react-feather";
import { Select } from "antd";

function CasinoKPI() {
  const todayRange = [dayjs(), dayjs()];

  const [isApiRunning, setIsApiRunning] = useState(true);
  const [showExtraFilters, setShowExtraFilters] = useState(true);
  const [sportsBookDates, setSportsBookDates] = useState(todayRange);
  const [selected, setSelected] = useState("SPORTSBOOK TURNOVER");

  const providers = [
    {
      value: "BGaming",
      label: "BGaming",
    },
    {
      value: "Booming",
      label: "Booming",
    },
    {
      value: "IMoon",
      label: "IMoon",
    },
    {
      value: "OddsChecker",
      label: "OddsChecker",
    },
    {
      value: "Action Network",
      label: "Action Network",
    },
    {
      value: "BetQL",
      label: "BetQL",
    },
  ];

  const game = [
    {
      value: "Holdem Poker",
      label: "Holdem Poker",
    },
    {
      value: "Blackjack",
      label: "Blackjack",
    },
    {
      value: "Roulette",
      label: "Roulette",
    },
    {
      value: "Craps",
      label: "Craps",
    },
    {
      value: "Baccarat",
      label: "Baccarat",
    },
  ];

  const gamecategory = [
    {
      value: "Table Games",
      label: "Table Games",
    },
    {
      value: "Slots",
      label: "Slots",
    },
    {
      value: "Live Casino",
      label: "Live Casino",
    },
    {
      value: "Video Poker",
      label: "Video Poker",
    },
    {
      value: "Specialty Games",
      label: "Specialty Games",
    },
  ];

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        enabled: true,
        mode: "nearest",
        intersect: false,
        callbacks: {
          label: function (context) {
            const value = context.raw;
            return `${context.dataset.label}: ${formatNumber(
              value,
              "en-US",
              "decimal",
              2
            )}\n`;
          },
        },
        backgroundColor: "#25252F",
        titleFont: {
          family: "Poppins-regular",
          size: 16,
          weight: "bold",
        },
        bodyFont: {
          family: "Poppins-regular",
          size: 14,
        },
        padding: 20,
        displayColors: true,
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      x: {
        display: false,
      },
      y: {
        display: false,
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return value / 1000 + "k";
          },
        },
      },
    },
    interaction: {
      mode: "index", // Show tooltip for all datasets at hovered index
      intersect: false,
      axis: "x", // Ensure crosshair lines show on the x-axis
    },
  };

  const data = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May"],
    datasets: [
      {
        label: "Total Providers",
        data: [1000, 2000, 1000, 5000, 3000],
        fill: false,
        backgroundColor: "#71BF8A",
        borderColor: "#71BF8A",
        borderRadius: 1,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
    ],
  };

  const dataGames = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May"],
    datasets: [
      {
        label: "Total Games",
        data: [1000, 2000, 1000, 5000, 3000],
        fill: false,
        backgroundColor: "#E74C3C",
        borderColor: "#E74C3C",
        borderRadius: 1,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
    ],
  };

  const SPORTSBOOK_OPTIONS = {
    "SPORTSBOOK TURNOVER": "sportsbook_turnover",
    "SPORTSBOOK GGR": "sportsbook_ggr",
  };

  const labels = ["Jan", "Feb", "Mar", "Apr", "May"];
  const acceptedBetsData = [1000, 2000, 1000, 5000, 3000];
  const cancelledBetsData = [500, 1000, 500, 2500, 1500];

  const data2 = {
    labels: labels,
    datasets: [
      {
        label: "Accepted Bets",
        data: acceptedBetsData,
        sum: 1000,
        borderColor: "#71BF8A",
        backgroundColor: "#71BF8A",
        borderRadius: 1,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
      {
        label: "Cancelled Bets",
        data: cancelledBetsData,
        sum: 2000,
        borderColor: "#E74C3C",
        backgroundColor: "#E74C3C",
        borderRadius: 1,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
    ],
    headers: [
      {
        title: "TURNOVER",
        amount: 799000,
        percentage: 7,
      },
      {
        title: "BETS COUNT",
        amount: 46320,
        percentage: -3,
      },
      {
        title: "GGR",
        amount: 28000,
        percentage: 3,
      },
    ],
  };


  useEffect(() => {
    console.log("casino kpi loaded")
    setIsApiRunning(true);
    setTimeout(() => {
      setIsApiRunning(false);
    }, 2000);
  }, []);

  return (
    <div className="casino-content">
      <div className="casino-content-header">
        <div className="casino-autocomplete-container">
          <CustomAutoComplete
            placeholder="Search"
            allOptions={providers}
            handleChange={() => {}}
            clearOptions={() => {}}
          />
          <div className="divider"></div>
          <div
            className="filter-buttons"
            onClick={() => setShowExtraFilters(!showExtraFilters)}
          >
            <Filter className="filter-icon" />
            {showExtraFilters ? (
              <ChevronUp className="filter-icon" />
            ) : (
              <ChevronDown className="filter-icon" />
            )}
          </div>
        </div>
      </div>
      <div
        className="casino-selectors"
        style={{ display: showExtraFilters ? "flex" : "none" }}
      >
        <div className="casino-selector">
          <span>Provider</span>
          <Select
            mode="multiple"
            placeholder="Not Selected"
            onChange={() => {}}
            options={providers}
          />
        </div>
        <div className="casino-selector">
          <span>Game</span>
          <Select
            mode="multiple"
            placeholder="Not Selected"
            onChange={() => {}}
            options={game}
          />
        </div>
        <div className="casino-selector">
          <span>Game Category</span>
          <Select
            mode="multiple"
            placeholder="Not Selected"
            onChange={() => {}}
            options={gamecategory}
          />
        </div>
      </div>
      <div
        className="casino-selector-action-buttons"
        style={{ display: showExtraFilters ? "flex" : "none" }}
      >
        <button className="clear">Clear Filters</button>
        <button className="apply">Apply</button>
      </div>
      <div className="casino-kpis">
        <div className="row bg-transparent px-0">
          <ProviderStatistics provider={null} isApiRunning={isApiRunning} />
        </div>
        <div className="row">
          <h3>Providers</h3>
          <div className="kpi-cards-top-body">
            <div className="left-content">
              <KpiCard
                isApiRunning={isApiRunning}
                title="ACTIVE"
                value={900}
                hugeValue={false}
                percentage={-9}
                backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
              />
              <KpiCard
                isApiRunning={isApiRunning}
                title="HIDDEN"
                value={100}
                hugeValue={false}
                percentage={50}
                backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
              />
            </div>

            <div className="right-content">
              <KpiCard
                isApiRunning={isApiRunning}
                title="TOTAL PROVIDERS"
                value={1000}
                hugeValue={true}
                percentage={20}
                backgroundColor={KPI_CARD_BACKGROUND.TRASNPARENT}
              />
              <div className="line-graph-container">
                <Line data={data} options={options} />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <h3>Games</h3>
          <div className="kpi-cards-top-body">
            <div className="left-content">
              <KpiCard
                isApiRunning={isApiRunning}
                title="ACTIVE"
                value={8000}
                hugeValue={false}
                percentage={-5}
                backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
              />
              <KpiCard
                isApiRunning={isApiRunning}
                title="HIDDEN"
                value={2000}
                hugeValue={false}
                percentage={5}
                backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
              />
            </div>

            <div className="right-content">
              <KpiCard
                isApiRunning={isApiRunning}
                title="TOTAL GAMES"
                value={10000}
                hugeValue={true}
                percentage={-3}
                backgroundColor={KPI_CARD_BACKGROUND.TRASNPARENT}
              />
              <div className="line-graph-container">
                <Line data={dataGames} options={options} />
              </div>
            </div>
          </div>
        </div>
        <div className="row p-0">
          <DashboardLineChart
            title={false}
            headers={data2.headers}
            data={data2}
            setSelected={setSelected}
            rightInfo={true}
            configOptions={SPORTSBOOK_OPTIONS}
            isApiRunning={isApiRunning}
            getData={() => {}}
            dates={todayRange}
            setDates={() => {}}
            showQuickSelect={true}
            showPresets={true}
          />
        </div>
        <div className="row">
          <ProviderDistribution isApiRunning={isApiRunning} />
        </div>
        <div className="row" style={{ width: "max-content" }}>
          <TopFiveGames isApiRunning={isApiRunning} />
        </div>
        <div className="row bg-transparent px-0">
          <ProviderStatistics provider="Jacktop" isApiRunning={isApiRunning} />
        </div>
        <div className="row bg-transparent px-0">
          <ProviderStatistics
            provider="Pragmatic"
            isApiRunning={isApiRunning}
          />
        </div>
        <div className="row bg-transparent px-0">
          <ProviderStatistics provider="Bgaming" isApiRunning={isApiRunning} />
        </div>
        <div className="row bg-transparent px-0">
          <ProviderStatistics
            provider="Booming Games"
            isApiRunning={isApiRunning}
          />
        </div>
      </div>
    </div>
  );
}

export default CasinoKPI;
